import store from "./store/index";
import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context(
    "./assets/locales",
    true,
    /[A-Za-z0-9-_]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\./i);
    if (!matched) return;
    const locale = matched[1];
    const loaded = locales(key);
    messages[locale] = { ...messages[locale] };
    Object.keys(loaded).forEach((namespace) => {
      messages[locale][namespace] = {
        ...(messages[locale][namespace] || {}),
        ...loaded[namespace],
      };
    });
  });
  return messages;
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale:
    store.state.user?.language_code || navigator.language?.slice(0, 2) || "en",
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});
